var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderEquipments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5712 31.7109L17.8569 31.7109",
    stroke: "#1552E8",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.8281H26.0001C31.6667 11.8281 32.2334 14.4781 32.6167 17.7115L34.1167 30.2115C34.6001 34.3115 33.3334 37.6615 27.5001 37.6615H12.5167C6.66671 37.6615 5.40004 34.3115 5.90004 30.2115L7.40006 17.7115C7.76672 14.4781 8.33337 11.8281 14 11.8281Z",
    stroke: "#081E54",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 14.3281V8.49479C13.333 5.99479 14.9997 4.32812 17.4997 4.32812H22.4997C24.9997 4.32812 26.6663 5.99479 26.6663 8.49479V14.3281",
    stroke: "#081E54",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5716 30.2813L11.4287 30.2812",
    stroke: "#081E54",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.7109C25 22.1109 24.95 22.4984 24.85 22.8734C24.7375 23.3734 24.5375 23.8609 24.275 24.2859C23.4125 25.7359 21.825 26.7109 20 26.7109C18.7125 26.7109 17.55 26.2234 16.675 25.4234C16.3 25.0984 15.975 24.7109 15.725 24.2859C15.2625 23.5359 15 22.6484 15 21.7109C15 20.3609 15.5375 19.1235 16.4125 18.2235C17.325 17.286 18.6 16.7109 20 16.7109C21.475 16.7109 22.8125 17.3485 23.7125 18.3735C24.5125 19.261 25 20.4359 25 21.7109Z",
    fill: "#A020FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8646 21.6914H18.1396",
    stroke: "white",
    strokeWidth: 1.07143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0029 19.8633V23.6008",
    stroke: "white",
    strokeWidth: 1.07143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEquipments);
export default __webpack_public_path__ + "static/media/OrderEquipments.04fba138d1b9fa1c8b05adc130bbdbb8.svg";
export { ForwardRef as ReactComponent };